import { Button, ButtonProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

interface ChakraButtonProps extends Omit<ButtonProps, 'borderRadius'> {
  children: React.ReactNode;
  variant?: 'solid' | 'outline' | 'ghost' | 'subtle' | 'surface' | 'plain';
  colorPalette?: 'sindiPurple' | 'sindiCyan' | 'sindiBlue' | 'gray';
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const SindiButton = forwardRef<HTMLButtonElement, ChakraButtonProps>(
  (
    {
      children,
      variant = 'solid',
      colorPalette = 'gray',
      size = 'md',
      ...props
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        variant={variant}
        colorPalette={colorPalette}
        size={size}
        rounded="sm"
        {...props}
      >
        {children}
      </Button>
    );
  }
);
